module.exports = __webpack_public_path__ + "img/user.72ed5ce3.svg";